import { render, staticRenderFns } from "./phoneCardRealName.vue?vue&type=template&id=2df61819"
import script from "./phoneCardRealName.vue?vue&type=script&lang=js"
export * from "./phoneCardRealName.vue?vue&type=script&lang=js"
import style0 from "./phoneCardRealName.vue?vue&type=style&index=0&id=2df61819&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports